// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--3cL7h";
export var socialLink = "styles-module--socialLink--20at4";